export default __webpack_public_path__ + "static/media/traveler-inside-train-3x.50d305f8.webp";